const getDefaultThemeValues = () => ({
  breakpoints: ["512px", "768px", "1024px", "350px"],
  spaces: [
    "0",
    "4px",
    "8px",
    "12px",
    "16px",
    "32px",
    "48px",
    "56px",
    "64px",
    "72px"
  ],
  fontSizes: [
    "0.8461rem",
    "0.9230rem",
    "1rem",
    "1.0769rem",
    "1.2307rem",
    "1.3846rem",
    "1.8461rem",
    "2.7692rem"
  ],
  fontWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  lineHeights: ["1rem", "1.15rem", "1.25rem", "1.5rem"],
  letterSpacings: ["normal", "0.1rem", "-0.05rem", "0.25rem"],
  fonts: ["proxima-nova, Arial, sans-serif"],
  colors: {
    neutral: [
      "#FFFFFF",
      "#F6F7F9",
      "#EBEDF0",
      "#E0E3E8",
      "#CBCFD7",
      "#B0B9C8",
      "#8C93A6",
      "#697489",
      "#464F5C",
      "#353C46",
      "#25292F"
    ],
    brand: [
      "#F6FBFF",
      "#EBF6FF",
      "#A3D6FF",
      "#52A6EC",
      "#1394E5",
      "#1E79C2",
      "#006AA9",
      "#005181",
      "#C9E7FF"
      // Alias for '250'
    ],
    success: ["#E1F4ED", "#E1F4ED", "#289F6B", "#207E56", "#185D44"],
    warning: ["#FFEFD8", "#E06C29", "#B25119", "#853C12"],
    danger: ["#FBEBED", "#FBEBED", "#ED5A64", "#C64252", "#A11B2B"]
  },
  shadows: [
    "0 1px 5px 0 rgba(0, 0, 0, 0.13), 0 2px 4px 0 rgba(0, 0, 0, 0.2)",
    "0 6px 20px 0 rgba(0, 0, 0, 0.24), 0 8px 17px 0 rgba(0, 0, 0, 0.19)",
    "0 12px 15px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19)",
    "0 16px 28px 0 rgba(0, 0, 0, 0.24), 0 25px 55px 0 rgba(0, 0, 0, 0.19)",
    "0 27px 24px 0 rgba(0, 0, 0, 0.24), 0 40px 77px 0 rgba(0, 0, 0, 0.19)"
  ],
  zIndex: [1e3, 2e3, 3e3, 500, 4e3],
  states: [
    null,
    "@media (prefers-reduced-motion: no-preference)",
    "@media (prefers-reduced-motion: reduce)",
    "&:first-child",
    "&:last-child",
    "&:odd",
    "&:even",
    "&:visited",
    "&:checked",
    "&:focus-within",
    "&:hover",
    "&:focus",
    "&:focus-visible",
    "&:active",
    "&:disabled, &[aria-disabled=true]",
    "&::placeholder"
  ]
});
export {
  getDefaultThemeValues
};
